import { Component, Fragment } from "react";
import * as React from "react";
import { OnboardTimelineItem, urlForTimelineItem } from "./OnboardTimeline";
import { DefaultButton, PrimaryButton } from "office-ui-fabric-react";
import H from "history";

interface OnboardNavigationProps {
    tenantId: string;
    schoolCode: string;

    currentTimelineItemKey: string;
    timelineItems: OnboardTimelineItem[];

    completeItem(): Promise<boolean>;

    children?: any;

    enableNext: boolean;
    enableSave: boolean;
    history: H.History;
}

interface OnboardNavigationState {
    previousItem?: OnboardTimelineItem;
    nextItem?: OnboardTimelineItem;
    currentIndex?: number;
}

export default class OnboardNavigation extends Component<OnboardNavigationProps, OnboardNavigationState>
{
    constructor(props: Readonly<OnboardNavigationProps>) {
        super(props);
        this.state = {
            previousItem: undefined,
            nextItem: undefined,
            currentIndex: undefined
        };
    }

    public componentDidMount() {

        if (this.props.timelineItems && this.props.currentTimelineItemKey) {
            this.setItemState();
        }
    }


    componentDidUpdate(prevProps: Readonly<OnboardNavigationProps>, prevState: Readonly<OnboardNavigationState>, snapshot?: any): void {
        if (this.props.timelineItems !== prevProps.timelineItems || this.props.currentTimelineItemKey != prevProps.currentTimelineItemKey) {
            this.setItemState();
        }
    }

    private setItemState() {
        const currentTimelineItem = this.props.timelineItems.filter(i => i.key == this.props.currentTimelineItemKey)[0];
        const currentIndex = this.props.timelineItems.indexOf(currentTimelineItem);

        const previousIndex = currentIndex - 1;
        const previousItem = previousIndex >= 0 ? this.props.timelineItems[previousIndex] : undefined;

        const nextIndex = currentIndex + 1;
        const nextItem = nextIndex <= (this.props.timelineItems.length - 1) ? this.props.timelineItems[nextIndex] : undefined;

        this.setState({
            previousItem,
            nextItem,
            currentIndex
        });
    }

    private onPreviousClicked = () => {
        if (this.state.previousItem) {
            const to = urlForTimelineItem(this.props.tenantId!, this.props.schoolCode!, this.state.previousItem);
            this.props.history.push(to);
        }
    }

    private onNextClicked = async () => {

        const itemCompleted = await this.props.completeItem();

        if (itemCompleted && this.state.nextItem) {
            const to = urlForTimelineItem(this.props.tenantId!, this.props.schoolCode!, this.state.nextItem);
            this.props.history.push(to);
        }
    }

    private onSaveClicked = async () => {
        await this.props.completeItem();
    }

    public render() {

        const currentStep = this.state.currentIndex !== undefined && this.state.currentIndex >= 0
            ? <span>{this.state.currentIndex + 1} / {this.props.timelineItems.length}</span>
            : null;

        const saveButton = (
                <div className={"timeline-navigation flex-row flex--align-items-flex-end p-1rem"}>
                <div className="flex-item--flex-2 flex-row">
                    <PrimaryButton style={{ margin: "auto" }} onClick={this.onSaveClicked} text={`Save Changes`} />
                    </div>
                </div>
            );

        return (
            <Fragment>
                {this.props.enableSave ? saveButton: null}
                <div className={"timeline-navigation flex-row flex--align-items-flex-center p-left-1rem p-right-1rem p-bottom-1rem"}>
                    <div className="flex-item--flex-2 flex-row">
                        {this.state.previousItem ? <DefaultButton className={"m-right-auto"} onClick={this.onPreviousClicked} text={`Back to ${this.state.previousItem?.name}`} /> : null}
                    </div>
                    <div className="flex-item--flex-1 flex-column flex--justify-content-center flex--align-items-center text-light text-tiny text-grey">
                        {currentStep}
                    </div>
                    <div className="flex-item--flex-2 flex-row">
                        {this.state.nextItem ? <PrimaryButton disabled={!this.props.enableNext} className={"m-left-auto"} onClick={this.onNextClicked} text={`Next to ${this.state.nextItem?.name}`} /> : null}
                    </div>
                </div>
                <div className="flex-row flex--justify-content-center">
                    {this.props.children}
                </div>
            </Fragment>
        );
    }
}